import React, { useEffect } from "react";
import HeaderMenu from "../../components/HeaderMenu";
import "./style.scss";
import Menu from "../../components/Menu";
import HeaderSpace from "../../components/HeaderSpace";
import { moveToSubCategory } from "../../helpers/DomHelper";
import menuStore from "../../stores/menu";
import { useLocation } from "react-router";
import Footer from "../../components/Footer";
import OrderIdle from "../../components/OrderIdle";
import orderStore from "../../stores/order";

const MenuPage = () => {
    const location = useLocation();

    useEffect(() => {
        menuStore.resetAddItemToOrder();
        menuStore.changeMenuItem();
        menuStore.changeRecommendationGroup();
        menuStore.returnToScanArticle = false;
        orderStore.resetCurrentLines();
        menuStore.selectedHalfAndHalfStep = 0;
        menuStore.selectedHalfAndHalfItems = [];
        menuStore.resetHalfAndHalfNavigation();


        if (location.hash !== "#ns") {
            setTimeout(() => {
                moveToSubCategory(menuStore.activeSubCategory);
            }, 100);
        }
    }, [location]);

    return <div className="MenuPage">
        <HeaderMenu />
        <HeaderSpace />
        <Menu />
        <Footer showDarkViewOrder={true} />
        <OrderIdle />
    </div>
}

export default MenuPage;
